import { actionGenerator, IReduxAction } from '../../utils/actions';
import { TDepositAccountPaymentID } from '../../reducers/depositAccount';
import { EPaymentProvider } from '../../../PaymentWidgetMicrofrontend';
import { EPaymentType } from '../../reducers/v2';

export const UPDATE_DEPOSIT_ACCOUNT_PAYMENT = 'DEPOSIT_ACCOUNT :: UPDATE_PAYMENT';

type TPayload = {
  paymentId: TDepositAccountPaymentID;
  provider: EPaymentProvider;
  type: EPaymentType;
};

export type TUpdateDepositAccountPaymentAction = IReduxAction<typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT, TPayload>;

export const updateDepositAccountPayment = actionGenerator<typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT, TPayload>(
  UPDATE_DEPOSIT_ACCOUNT_PAYMENT,
);
